(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["menu-mega-menu"] && !Shopify.designMode) return;
  try {
    
  class MegaMenu extends HTMLElement {
    connectedCallback() {
      this.animated = this.dataset.animations === 'true';
      this.cardsPerRow = parseInt(this.dataset.cardsPerRow, 10) || 6;

      // Every document/window listener is tied to this signal, so a theme
      // editor re-render (which disconnects this element) cleans them up.
      this.listeners = new AbortController();
      const signal = this.listeners.signal;

      // DOM restructuring + drill build happen once per element; listeners
      // are (re)bound on every connect.
      if (!this.built) {
        this.drillEl = this.querySelector('[data-drill]');
        this.safe('groupPanelChildren', () => this.groupPanelChildren());
        // Before buildDrill, which copies link labels/hrefs into the mobile drill.
        this.safe('localizePriceLinks', () => this.localizePriceLinks());
        this.safe('buildDrill', () => this.buildDrill());
        this.built = true;
      }

      this.safe('markFlippedCards', () => this.markFlippedCards());
      this.safe('bindPanels', () => this.bindPanels(signal));
      this.safe('bindCards', () => this.bindCards(signal));
      this.safe('bindIconStrips', () => this.bindIconStrips(signal));
      this.safe('relocateIntoThemeDrawer', () => this.relocateIntoThemeDrawer(signal));

      window.addEventListener('resize', () => this.safe('markFlippedCards', () => this.markFlippedCards()), { signal });
    }

    disconnectedCallback() {
      if (this.listeners) this.listeners.abort();
      if (this.drawerObserver) this.drawerObserver.disconnect();

      // The drill lives in the theme drawer, outside this element. If this
      // element is gone for good (section re-rendered/removed), take it too.
      setTimeout(() => {
        if (!this.isConnected && this.drillEl && !this.contains(this.drillEl)) this.drillEl.remove();
      }, 0);
    }

    safe(name, fn) {
      try { fn(); }
      catch (e) { console.error('MegaMenu[' + name + ']', e); }
    }

    /* ---------- price-filter links in the shopper's currency. The range
       lives in the link's own ?price=min:max, in store currency; it is
       converted with the same Shopify.currency.rate Boost is given, and
       the amounts in the label are swapped to match, keeping its wording.
       Labels follow the "Under $1,000" / "$1,000 – $1,249" / "$2,000+"
       pattern: a min:max range shows max − 1 as its upper amount. ---------- */
    localizePriceLinks() {
      const cur = window.Shopify && window.Shopify.currency;
      const rate = cur ? parseFloat(cur.rate) : 1;
      if (!cur || !cur.active || !rate || rate === 1) return;

      let format;
      try {
        const nf = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: cur.active, currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 0, maximumFractionDigits: 0
        });
        format = (n) => nf.format(n);
      } catch (e) {
        format = (n) => cur.active + ' ' + n.toLocaleString();
      }

      // Round to a clean step scaled to the currency: 50 for EUR/GBP/CAD/AUD,
      // 5,000 for JPY/INR, 50,000 for KRW. Neighbouring ranges round the same
      // boundary the same way, so they stay contiguous (e.g. ...:1150 and 1150:...).
      const step = 50 * Math.pow(10, Math.round(Math.log10(rate)));
      const convert = (n) => Math.round(n * rate / step) * step;
      const AMOUNT = /[^\s\d–—-]*\d[\d,.]*/g;

      this.querySelectorAll('a[href*="price="]').forEach((a) => {
        const href = a.getAttribute('href');
        const url = new URL(href, location.origin);
        const m = /^(\d*):(\d*)$/.exec(url.searchParams.get('price') || '');
        if (!m || (!m[1] && !m[2])) return;

        const min = m[1] ? convert(+m[1]) : null;
        const max = m[2] ? convert(+m[2]) : null;
        if (min != null && max != null && max <= min) return;
        url.searchParams.set('price', (min ?? '') + ':' + (max ?? ''));
        a.setAttribute('href', /^https?:/.test(href) ? url.href : url.pathname + url.search + url.hash);

        // Leave the label alone if its amounts don't line up with the range.
        const amounts = min != null && max != null ? [min, max - 1] : [min ?? max];
        const title = a.querySelector('.link-item__title') || a;
        const texts = Array.from(title.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
        const found = texts.reduce((c, n) => c + (n.data.match(AMOUNT) || []).length, 0);
        if (found !== amounts.length) return;

        let i = 0;
        texts.forEach((n) => { n.data = n.data.replace(AMOUNT, () => format(amounts[i++])); });
      });
    }

    /* ---------- wrap blocks into the layout grids ---------- */
    groupPanelChildren() {
      this.querySelectorAll('[data-panel-content] .mega-panel__inner').forEach((inner) => {
        // Classify each block in the order it was actually placed, then group
        // only CONSECUTIVE runs of the same type, inserting each group at its
        // own position. This preserves block order, so a full-width promo tile
        // placed between two sets of columns renders between them instead of
        // being hoisted to the top or bottom of the panel.
        //
        // Shopify wraps each rendered block in its own element, so the check
        // looks at both the child itself and its descendants.
        const typeOf = (el) => {
          if (el.matches('[data-feat-card]') || el.querySelector('[data-feat-card]')) return 'card';
          if (el.matches('[data-link-col]') || el.querySelector('[data-link-col]')) return 'col';
          if (el.matches('[data-all-brands]') || el.querySelector('[data-all-brands]')) return 'brands';
          if (el.matches('[data-promo-tile]') || el.querySelector('[data-promo-tile]')) {
            const tile = el.matches('[data-promo-tile]') ? el : el.querySelector('[data-promo-tile]');
            return tile.classList.contains('promo-tile--rail') ? 'rail' : 'tile';
          }
          return 'other';
        };

        const children = Array.from(inner.children);
        if (!children.length) return;

        const runs = [];
        children.forEach((el) => {
          const t = typeOf(el);
          const last = runs[runs.length - 1];
          if (last && last.type === t) last.els.push(el);
          else runs.push({ type: t, els: [el] });
        });

        // Rail tiles and all-brands lists always pair into the bottom 7/3 row
        // regardless of where they sit, so collect those out separately.
        const railEls = [];
        const brandEls = [];
        runs.forEach((run) => {
          if (run.type === 'rail') railEls.push(...run.els);
          if (run.type === 'brands') brandEls.push(...run.els);
        });

        const frag = document.createDocumentFragment();

        runs.forEach((run) => {
          if (run.type === 'rail' || run.type === 'brands') return;

          if (run.type === 'card') {
            const grid = document.createElement('div');
            grid.className = 'mega-panel__cards';
            run.els.forEach(el => grid.appendChild(el));
            frag.appendChild(grid);
            return;
          }

          if (run.type === 'col') {
            const grid = document.createElement('div');
            grid.className = 'mega-panel__cols';
            run.els.forEach(el => grid.appendChild(el));
            frag.appendChild(grid);
            return;
          }

          // full-width tiles and anything else stay exactly where placed
          run.els.forEach(el => frag.appendChild(el));
        });

        if (brandEls.length || railEls.length) {
          const bottom = document.createElement('div');
          bottom.className = 'mega-panel__bottom';
          if (!railEls.length) bottom.classList.add('mega-panel__bottom--no-rail');

          const left = document.createElement('div');
          brandEls.forEach(b => left.appendChild(b));
          bottom.appendChild(left);

          if (railEls.length) {
            const rail = document.createElement('div');
            rail.className = 'mega-panel__rail';
            railEls.forEach(t => rail.appendChild(t));
            bottom.appendChild(rail);
          }

          frag.appendChild(bottom);
        }

        inner.appendChild(frag);
      });
    }

    /* ---------- flip popup for last card in each row ---------- */
    markFlippedCards() {
      this.querySelectorAll('.mega-panel__cards').forEach((grid) => {
        const cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || this.cardsPerRow;
        const cards = Array.from(grid.querySelectorAll('[data-feat-card]'));
        cards.forEach((card, idx) => {
          const isLastInRow = (idx + 1) % cols === 0 || idx === cards.length - 1;
          card.classList.toggle('is-flipped', isLastInRow);
        });
      });
    }

    /* ---------- desktop + mobile panel open/close — CLICK ONLY ---------- */
    bindPanels(signal) {
      const items = Array.from(this.querySelectorAll('[data-nav-panel]'));
      const controls = [];

      items.forEach((item) => {
        const trigger = item.querySelector('[data-panel-trigger]');
        const panel = item.querySelector('[data-panel-content]');
        if (!trigger || !panel) return;

        const open = () => {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          item.classList.add('is-open');
        };
        const close = () => {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          item.classList.remove('is-open');
        };

        controls.push({ item, panel, open, close });

        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = !panel.hidden;
          controls.forEach(c => c.close());
          if (!isOpen) open();
        }, { signal });
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) controls.forEach(c => c.close());
      }, { signal });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') controls.forEach(c => c.close());
      }, { signal });
    }

    /* ---------- featured card hover / tap ---------- */
    bindCards(signal) {
      const cards = Array.from(this.querySelectorAll('[data-feat-card]'));

      cards.forEach((card) => {
        if (card.classList.contains('feat-card--pinned')) return;

        const expand = () => card.setAttribute('aria-expanded', 'true');
        const collapse = () => card.setAttribute('aria-expanded', 'false');

        card.addEventListener('mouseenter', expand, { signal });
        card.addEventListener('mouseleave', collapse, { signal });

        card.addEventListener('touchstart', (e) => {
          if (card.getAttribute('aria-expanded') !== 'true') {
            e.preventDefault();
            cards.forEach(c => { if (c !== card) c.setAttribute('aria-expanded', 'false'); });
            expand();
          }
        }, { passive: false, signal });
      });

      document.addEventListener('touchstart', (e) => {
        cards.forEach((card) => {
          if (!card.contains(e.target) && !card.classList.contains('feat-card--pinned')) {
            card.setAttribute('aria-expanded', 'false');
          }
        });
      }, { signal });
    }

    /* ---------- icon strip arrows ---------- */
    bindIconStrips(signal) {
      this.querySelectorAll('[data-icon-strip]').forEach((strip) => {
        const track = strip.querySelector('.icon-strip__track');
        const dots = strip.querySelector('[data-icon-strip-dots]');
        const prev = strip.querySelector('[data-icon-strip-prev]');
        const next = strip.querySelector('[data-icon-strip-next]');
        if (!track) return;

        if (dots) {
          dots.innerHTML = Array.from(track.querySelectorAll('.icon-strip-item'))
            .map(() => '<span></span>').join('');
        }

        const step = (dir) => {
          const item = track.querySelector('.icon-strip-item');
          const amt = item ? item.getBoundingClientRect().width + 24 : 200;
          track.scrollBy({ left: dir * amt, behavior: 'smooth' });
        };
        if (prev) prev.addEventListener('click', () => step(-1), { signal });
        if (next) next.addEventListener('click', () => step(1), { signal });
      });
    }

    /* ---------- mobile drill-down ----------
       Built from the same desktop markup, so there is no separate mobile
       menu to maintain. Each block declares how it appears on mobile with
       data-mobile on its root element:

         group  → a row that opens its own screen of links  (Link Column)
         list   → heading + rows shown inline                (All Brands)
         links  → its links shown inline as rows             (Icon Strip)
         link   → the block itself is one row, labelled by
                  data-mobile-label                          (Featured Card)
         clone  → copied in as-is                            (Promo Tile)

       A block with no data-mobile (or an unknown value) still shows: its
       links become inline rows. Anything inside .u-hide-mobile — the
       "Hide on mobile" checkbox on every block — is skipped at every level,
       the same class the CSS uses, so both views always agree. */
    buildDrill() {
      const drill = this.drillEl;
      if (!drill) return;

      const viewsEl = drill.querySelector('[data-drill-views]');
      const backBtn = drill.querySelector('[data-drill-back]');
      const titleEl = drill.querySelector('[data-drill-title]');

      const stack = [];
      let seq = 0;

      const escapeHTML = (s) => String(s).replace(/[&<>"']/g, c => (
        { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
      ));

      const hiddenOnMobile = (el) => !!el.closest('.u-hide-mobile');

      // Links inside a block that become rows (hidden ones dropped).
      const linksIn = (el) => Array.from(el.querySelectorAll('a[href]')).filter(a => !hiddenOnMobile(a));

      // A panel's top-level mobile items, in DOM order: blocks with a role,
      // plus loose links no role block owns (e.g. the panel's "View all").
      const itemsIn = (panel) => Array.from(panel.querySelectorAll('[data-mobile], a[href]')).filter((el) => {
        const owner = el.parentElement.closest('[data-mobile], [data-panel-content]');
        return owner === panel && !hiddenOnMobile(el);
      });

      const makeView = () => {
        const v = document.createElement('div');
        v.className = 'mega-drill__view';
        v.id = 'mega-drill-view-' + this.id + '-' + (++seq);
        viewsEl.appendChild(v);
        return v;
      };

      const list = () => {
        const ul = document.createElement('ul');
        ul.className = 'mega-drill__list';
        return ul;
      };

      const showView = (id, title) => {
        viewsEl.querySelectorAll('.mega-drill__view').forEach(v => v.classList.remove('is-active'));
        const v = viewsEl.querySelector('#' + CSS.escape(id));
        if (v) v.classList.add('is-active');
        const atRoot = stack.length <= 1;
        titleEl.textContent = atRoot ? '' : title;
        titleEl.classList.toggle('is-hidden', atRoot);
        backBtn.classList.toggle('is-hidden', atRoot);
      };

      const push = (id, title) => { stack.push({ id, title }); showView(id, title); };

      backBtn.addEventListener('click', () => {
        if (stack.length > 1) {
          stack.pop();
          const p = stack[stack.length - 1];
          showView(p.id, p.title);
        }
      });

      const parentRow = (label, onClick, badgeHTML) => {
        const li = document.createElement('li');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mega-drill__row mega-drill__row--parent';
        btn.innerHTML = '<span class="mega-drill__row-label">' + escapeHTML(label) + (badgeHTML || '') +
          '</span><span class="mega-drill__row-arrow" aria-hidden="true"></span>';
        btn.addEventListener('click', onClick);
        li.appendChild(btn);
        return li;
      };

      // iconStyle comes from the block's data-mobile-icons: "logo" (brand
      // logos, initials when missing) or "badge" (icon strip images, nothing
      // when missing). The image URL is the link's data-icon.
      const linkRow = (anchor, iconStyle, label) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'mega-drill__row';
        a.href = anchor.getAttribute('href') || '#';
        const parentLi = anchor.closest('li');
        if (parentLi && parentLi.classList.contains('is-sub')) a.classList.add('is-sub');
        if (anchor.hasAttribute('data-mobile-footer')) a.classList.add('is-footer');

        let iconHTML = '';
        if (iconStyle) {
          const src = anchor.dataset.icon;
          if (src) {
            iconHTML = '<img class="mega-drill__icon mega-drill__icon--' + escapeHTML(iconStyle) +
              '" src="' + escapeHTML(src) + '" alt="">';
          } else if (iconStyle === 'logo') {
            const name = anchor.textContent.trim();
            const initials = name.replace(/[^A-Za-z0-9 ]/g, '').split(' ')
              .filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();
            iconHTML = '<span class="mega-drill__icon">' + initials + '</span>';
          }
        }

        const content = label != null ? escapeHTML(label) : anchor.innerHTML;
        a.innerHTML = '<span class="mega-drill__row-label">' + iconHTML + content + '</span>';
        li.appendChild(a);
        return li;
      };

      // Fills one panel's screen. Consecutive rows share a list; a heading
      // or cloned tile ends it, so everything keeps its placed order.
      const fillPanelView = (panel, panelView) => {
        let rows = null;
        const addRow = (li) => {
          if (!rows) { rows = list(); panelView.appendChild(rows); }
          rows.appendChild(li);
        };
        const endRows = () => { rows = null; };

        itemsIn(panel).forEach((el) => {
          const role = el.dataset.mobile || 'links';

          if (role === 'group') {
            const links = linksIn(el);
            if (!links.length) return;
            const title = el.dataset.mobileTitle || '';
            const groupView = makeView();
            const groupList = list();
            groupView.appendChild(groupList);
            links.forEach(a => groupList.appendChild(linkRow(a, false)));
            addRow(parentRow(title, () => push(groupView.id, title)));
            return;
          }

          if (role === 'list') {
            const links = linksIn(el);
            if (!links.length) return;
            endRows();
            const heading = document.createElement('p');
            heading.className = 'mega-drill__section-title';
            heading.textContent = el.dataset.mobileTitle || '';
            panelView.appendChild(heading);
            links.forEach(a => addRow(linkRow(a, el.dataset.mobileIcons)));
            endRows();
            return;
          }

          if (role === 'clone') {
            endRows();
            panelView.appendChild(el.cloneNode(true));
            return;
          }

          if (role === 'link') {
            addRow(linkRow(el, false, el.dataset.mobileLabel || el.textContent.trim()));
            return;
          }

          // 'links', a loose <a>, or any block without a known role
          if (el.matches('a[href]')) addRow(linkRow(el, false));
          else linksIn(el).forEach(a => addRow(linkRow(a, el.dataset.mobileIcons)));
        });
      };

      const rootView = makeView();
      const rootList = list();
      rootView.appendChild(rootList);

      this.querySelectorAll('[data-nav-panel]').forEach((item) => {
        if (hiddenOnMobile(item)) return;

        const label = item.dataset.menuLabel || '';
        const panel = item.querySelector('[data-panel-content]');
        const badgeEl = item.querySelector('.mega-nav__badge');
        const badgeHTML = badgeEl
          ? ' <span class="mega-badge" style="background:' +
            (badgeEl.style.background || 'var(--mega-accent)') + '">' +
            escapeHTML(badgeEl.textContent.trim()) + '</span>'
          : '';

        const plainRow = (href) => {
          const li = document.createElement('li');
          li.innerHTML = '<a class="mega-drill__row" href="' + escapeHTML(href) +
            '"><span class="mega-drill__row-label">' + escapeHTML(label) + badgeHTML + '</span></a>';
          rootList.appendChild(li);
        };

        if (!panel) {
          const link = item.querySelector('a');
          plainRow(link ? link.getAttribute('href') : '#');
          return;
        }

        const panelView = makeView();
        fillPanelView(panel, panelView);

        // Everything in the panel is hidden on mobile: fall back to a plain
        // link if the item has a URL, otherwise leave it out.
        if (!panelView.children.length) {
          panelView.remove();
          if (item.dataset.menuUrl) plainRow(item.dataset.menuUrl);
          return;
        }

        rootList.appendChild(parentRow(label, () => push(panelView.id, label), badgeHTML));
      });

      push(rootView.id, '');
      drill.classList.add('is-ready');
    }

   /* ---------- move our drill content into the theme's own mobile
       drawer, so search/currency/account/wishlist/social stay entirely
       theme-owned instead of us re-implementing them. The drawer is a
       lazily-instantiated <template>, so we watch for the slot to
       appear rather than assuming a fixed load order. ---------- */
    relocateIntoThemeDrawer(signal) {
      const drillEl = this.drillEl;
      if (!drillEl) return;
      const owner = drillEl.dataset.drillOwner;

      const tryMove = () => {
        if (!this.isConnected) return false;
        const slot = document.querySelector('[id^="mega-menu-mobile-slot"]');
        if (!slot || slot.contains(drillEl)) return false;

        // Drop a stale drill left by an earlier render of this section
        // (theme editor re-renders), so the drawer never shows two menus.
        slot.querySelectorAll('[data-drill-owner]').forEach((d) => {
          if (d !== drillEl && d.dataset.drillOwner === owner) d.remove();
        });

        slot.appendChild(drillEl);
        return true;
      };

      tryMove();

      if (this.drawerObserver) this.drawerObserver.disconnect();
      this.drawerObserver = new MutationObserver(() => { tryMove(); });
      this.drawerObserver.observe(document.body, { childList: true, subtree: true });

      document.addEventListener('click', (e) => {
        if (e.target.closest('.mobile-nav-toggle')) {
          setTimeout(tryMove, 0);
          setTimeout(tryMove, 150);
        }
      }, { signal });
    }
  }

  if (!customElements.get('mega-menu')) {
    customElements.define('mega-menu', MegaMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
